/* global axios */

const knowledgeProxy = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge${path}`;

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async bulkAssignStaffToService({ rootGetters }, payload) {
    const accountId = rootGetters.getCurrentAccountId;
    try {
      const res = await axios.put(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/services/${payload.service_id}/staff/bulk`),
        payload
      );
      return res.data;
    } catch (error) {
      console.error('Bulk assign staff to services failed:', error);
      throw error.response?.data || error;
    }
  },

  async bulkAssignServicesToStaff({ rootGetters }, payload) {
    const accountId = rootGetters.getCurrentAccountId;
    try {
      const res = await axios.put(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/branch-staff-services/bulk`),
        payload
      );
      return res.data;
    } catch (error) {
      console.error('Bulk assign staff to services failed:', error);
      throw error.response?.data || error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
